export default function () {
  const query = {}
  const searchString = window.location.search.slice(1) || window.location.hash.slice(window.location.hash.indexOf('?'))

  const reg = /&?(\w+)=([^&]+)(?:$|&)/igm

  while (reg.test(searchString)) {
    query[RegExp.$1] = decodeURIComponent(RegExp.$2)
  }

  return query
}
